import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

const ONBOARDING_ALLOWED_PATHS = ['/onboarding', '/sign-i9', '/sign-form'];

export default function PrivateRoute({ children, roles }) {
  const { isAuthenticated, isInitialized, pendingMFA, user } = useAuthStore();
  const location = useLocation();

  if (!isInitialized) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
      </div>
    );
  }

  if (!isAuthenticated && !pendingMFA) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!pendingMFA && roles && !roles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Profile not yet completed → gate all routes except /complete-profile
  if (isAuthenticated && user?.profile_completed === false && location.pathname !== '/complete-profile') {
    return <Navigate to="/complete-profile" replace />;
  }

  // Once profile is done, prevent going back to /complete-profile
  if (isAuthenticated && user?.profile_completed === true && location.pathname === '/complete-profile') {
    return <Navigate to="/onboarding" replace />;
  }

  // Onboarding not yet complete → restrict to onboarding paths only
  if (
    isAuthenticated &&
    user?.profile_completed === true &&
    user?.onboarding_complete === false &&
    !ONBOARDING_ALLOWED_PATHS.some((p) => location.pathname.startsWith(p))
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  // Once fully active, prevent going back to /onboarding
  if (isAuthenticated && user?.onboarding_complete === true && location.pathname === '/onboarding') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
